import React, { Component } from 'react';
import { connect } from 'react-redux';

import List from '@material-ui/core/List';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

export class ManageGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: [],
            open: false,
            value: 0,
            addUser: '',
            addGroup: '',
            addUserToGroup: '',
            filesOpen: {},
            selectedGroupName: '',
            selectedUserId: '',
            showRemoveGroupConfirm: false,
            showError: false,
        };
    }

    componentDidMount() {
        // Load groups.
        this.getGroups();
    }

    getGroups = () => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/group/list", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(resp => resp.json())
                .then(data => {
                    console.log("GROUPS DATA: ", data);
                    var groups = {};
                    var groupList = [];
                    for (var i = 0; i < data.length; i++) {
                        var group = data[i];
                        if (!groups.hasOwnProperty(group.groupName)) {
                            groups[group.groupName] = [];
                        }
                        groups[group.groupName].push(group.userId);
                    }

                    for (var key of Object.keys(groups)) {
                        groupList.push({ 'groupName': key, 'userIds': this.sortUserIds(groups[key]) });
                    }
                    // Sorts group name alphabetically
                    groupList.sort(function (a, b) {
                        var groupNameA = a.groupName.toUpperCase();
                        var groupNameB = b.groupName.toUpperCase();
                        return (groupNameA < groupNameB) ? -1 : (groupNameA > groupNameB) ? 1 : 0;
                    });
                    console.log("GROUP LIST: ", groupList);
                    this.setState({ groups: groupList });
                });
        }
    }

    convertUserToDisplayName = (user) => {
        return this.props.memberIdMap[user['id']].firstName + " " + this.props.memberIdMap[user['id']].lastName;
    }

    sortUserIds = (userIds) => {
        var newUserIds = [...userIds].filter(id => this.props.memberIdMap.hasOwnProperty(id));
        return newUserIds.sort((a, b) => {
            var nameA = this.convertUserToDisplayName(this.props.memberIdMap[a]);
            var nameB = this.convertUserToDisplayName(this.props.memberIdMap[b]);
            return nameA.localeCompare(nameB);
        });
    }

    removeUserFromGroup = (groupName, userId) => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/group/RemoveUserFromGroup", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ 'UserId': userId, "GroupName": groupName })
            })
                .then(resp => resp.json())
                .then(data => {
                    console.log(data);
                    var groups = {};
                    var groupList = [];
                    for (var i = 0; i < data.length; i++) {
                        var group = data[i];
                        if (!groups.hasOwnProperty(group.groupName)) {
                            groups[group.groupName] = [];
                        }
                        groups[group.groupName].push(group.userId);
                    }

                    for (var key of Object.keys(groups)) {
                        groupList.push({ 'groupName': key, 'userIds': this.sortUserIds(groups[key]) });
                    }
                    groupList.sort(function (a, b) {
                        var groupNameA = a.groupName.toUpperCase();
                        var groupNameB = b.groupName.toUpperCase();
                        return (groupNameA < groupNameB) ? -1 : (groupNameA > groupNameB) ? 1 : 0;
                    });
                    console.log(groupList);
                    this.setState({ groups: groupList });
                });
        }
    }

    removeGroup = (groupName) => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/group/RemoveGroup", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ "GroupName": groupName })
            })
                .then(resp => resp.json())
                .then(data => {
                    console.log(data);
                    var groups = {};
                    var groupList = [];
                    for (var i = 0; i < data.length; i++) {
                        var group = data[i];
                        if (!groups.hasOwnProperty(group.groupName)) {
                            groups[group.groupName] = [];
                        }
                        groups[group.groupName].push(group.userId);
                    }

                    for (var key of Object.keys(groups)) {
                        groupList.push({ 'groupName': key, 'userIds': this.sortUserIds(groups[key]) });
                    }
                    groupList.sort(function (a, b) {
                        var groupNameA = a.groupName.toUpperCase();
                        var groupNameB = b.groupName.toUpperCase();
                        return (groupNameA < groupNameB) ? -1 : (groupNameA > groupNameB) ? 1 : 0;
                    });
                    console.log(groupList);
                    this.setState({ groups: groupList });
                });
        }
    }

    addUserToGroup = (groupName, userId) => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/group/AddUserToGroup", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ 'UserId': userId, "GroupName": groupName })
            })
                .then(resp => resp.json())
                .then(data => {
                    console.log(data);
                    var groups = {};
                    var groupList = [];
                    for (var i = 0; i < data.length; i++) {
                        var group = data[i];
                        if (!groups.hasOwnProperty(group.groupName)) {
                            groups[group.groupName] = [];
                        }
                        groups[group.groupName].push(group.userId);
                    }

                    for (var key of Object.keys(groups)) {
                        groupList.push({ 'groupName': key, 'userIds': this.sortUserIds(groups[key]) });
                    }
                    groupList.sort(function (a, b) {
                        var groupNameA = a.groupName.toUpperCase();
                        var groupNameB = b.groupName.toUpperCase();
                        return (groupNameA < groupNameB) ? -1 : (groupNameA > groupNameB) ? 1 : 0;
                    });
                    console.log(groupList);
                    this.setState({ groups: groupList });
                });
        }
    }

    postAddGroup = (groupName) => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/group/AddGroup", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ "GroupName": groupName })
            })
                .then(resp => resp.json())
                .then(data => {
                    console.log("Response");
                    console.log(data);
                    var tempGroups = [...this.state.groups];
                    tempGroups.push(data);
                    this.setState({ groups: tempGroups, addGroup: '' });
                });
        }
    }

    handleSelectedUserCallback = (selectedUser) => {
        this.setState({ selectedUser: selectedUser }, () => {
            console.log("[ManageUser] this.state.selectedUser: ", this.state.selectedUser);
        });
    };

    handleChange = property => event => {
        let newSelectedUser = this.state.selectedUser;
        newSelectedUser[property] = event.target.value;
        this.setState({ selectedUser: newSelectedUser }, () => {
        });
    };

    handleAddGroupChange = event => {
        this.setState({ addUserToGroup: event.target.value });
    };

    handleAddUser = event => {
        console.log("Adding a user");
        if (this.state.addUserToGroup !== '' && this.state.addUser !== '') {
            this.addUserToGroup(this.state.addUserToGroup, this.props.memberNameMap[this.state.addUser].id);
            this.setState({ addUserToGroup: '', addUser: '' });
        }
    }

    handleShowRemoveGroupConfirm = () => {
        if (this.state.selectedGroupName !== '') {
            this.setState({ showRemoveGroupConfirm: true });
        } else {
            this.setState({ showError: true });
        }
    };

    closeRemoveGroupConfirm = () => {
        this.setState({ showRemoveGroupConfirm: false });
    };

    handleRemoveGroupConfirm = () => {
        console.log("removed group");
        if (this.state.selectedGroupName !== '') {
            this.removeGroup(this.state.selectedGroupName);
            this.setState({ showRemoveGroupConfirm: false });
        }
    };

    handleRemoveUserFromGroup = () => {
        console.log("removed user from group");
        if (this.state.selectedGroupName !== '' && this.state.selectedUserId !== '') {
            this.removeUserFromGroup(this.state.selectedGroupName, this.state.selectedUserId);
        }
    };

    handleAddUserSelect = event => {
        console.log(event.target.value);
        this.setState({ addUser: event.target.value });
    };

    handleGroupSelect = event => {
        console.log(event.target.value);
        this.setState({ addUser: event.target.value });
    };

    handleAddNewGroupChange = event => {
        console.log("handleAddNewGroupChange called; adding new group");
        this.setState({ addGroup: event.target.value }, () => { console.log("this.state.addGroup: ", this.state.addGroup); });
    };

    addAGroup = () => {
        console.log("Adding a group");
        if (this.state.addGroup === "") {
            return;
        }
        this.postAddGroup(this.state.addGroup);
        //var tempGroups = [...this.state.groups];
        //tempGroups.push({ groupName: this.state.addGroup, userIds: [] });
        //this.setState({ groups: tempGroups, addGroup: '' });
    };

    onClickUser = clickedUserProps => event => {
        this.setState({ selectedGroupName: clickedUserProps['group']['groupName'], selectedUserId: clickedUserProps['id'], showError: false });
    }

    handleFilesClick = (groupName) => event => {
        console.log(groupName);
        console.log(this.state.filesOpen);
        this.setState({ showError: false });
        var tempFileOpen = { ...this.state.filesOpen };
        if (!tempFileOpen.hasOwnProperty(groupName)) {
            tempFileOpen[groupName] = true;
        } else {
            tempFileOpen[groupName] = !tempFileOpen[groupName];
        }
        this.setState({ filesOpen: tempFileOpen, selectedGroupName: groupName });
    };

    render() {
        const groupList = [];

        this.state.groups.map((group, i) => {
            if (group['userIds'] === undefined) {
                group['userIds'] = [];
            } else {
                group['userIds'] = group['userIds'].filter(id => this.props.memberIdMap.hasOwnProperty(id));
            }
            groupList.push(
                <div>
                    <List
                        component="nav"
                        key={i}
                        disablePadding
                        style={{ padding: '0px', paddingLeft: '5px' }}
                    >
                        <ListItem button onClick={this.handleFilesClick(group['groupName'])} style={{ padding: '2px' }}>
                            <ListItemText
                                disableTypography
                                primary={group['groupName']}
                                style={this.state.selectedGroupName == group['groupName'] ? { fontWeight: "bold", padding: '0px', fontSize: '12px' } : { padding: '0px', fontSize: '12px' }}
                            />
                            {this.state.filesOpen['groupName'] ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={this.state.filesOpen[group['groupName']]} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {group.userIds.map((id, j) =>
                                    <ListItem key={j} onClick={this.onClickUser({ id: id, group: group })} button style={{ padding: '2px', paddingLeft: '35px' }}>
                                        <ListItemText
                                            disableTypography
                                            style={this.state.selectedUserId == id ? { fontWeight: "bold", fontSize: '12px' } : { fontSize: '12px' }}
                                            primary={this.props.memberIdMap[id].firstName + " " + this.props.memberIdMap[id].lastName}
                                        />
                                    </ListItem>)
                                }
                            </List>
                        </Collapse>
                    </List>
                </div>

            );
        });

        return (
            <div style={{ backgroundColor: '#f5f5f5', height: '100%' }}>
                <Grid container spacing={0} justify="flex-start" style={{}}>

                    {/*Group List*/}
                    <Grid item xs={5} style={{ paddingTop: '10px', paddingLeft: '10px' }}>
                        <Card style={{ height: '275px', maxWidth: '200px' }}>
                            <Grid container item xs={12}>
                                <Grid item xs={12}>
                                    <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Group List</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <List style={{ width: '100%', maxWidth: '360px', maxHeight: '241px', overflow: 'auto', position: 'relative' }}>

                                        {/*<ListItem classes={{ root: classes.item }}>
                      <ListItemText primary="Trash" />
                    </ListItem>
                    */}

                                        {groupList}
                                    </List>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>


                    <Grid item container xs={7} style={{ paddingTop: '10px', paddingRight: '10px' }}>

                        {/*Add A Member*/}
                        <Grid item xs={12} style={{}}>
                            <Card style={{}}>

                                {/*Add A Member Card*/}
                                <Grid container item xs={12}>

                                    {/*Add A Member To Group Title*/}
                                    <Grid item xs={12} style={{ marginBottom: '8px' }}>
                                        <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Add A Member To Group</Typography>
                                    </Grid>

                                    {/*Select a group to add a member to*/}
                                    <Grid item xs={6}>
                                        <Typography align="left" style={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '15px' }}>Select A Group</Typography>
                                        <FormControl style={{ paddingLeft: '15px' }}>
                                            <Select
                                                value={this.state.addUserToGroup}
                                                onChange={this.handleAddGroupChange}
                                                autoWidth={true}
                                                style={{ width: '134px' }}
                                            >
                                                {this.state.groups.map((group, i) => <MenuItem style={{ minHeight: '25px' }} key={i} value={group['groupName']}>{group['groupName']}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/*Select the member to add*/}
                                    <Grid item xs={6}>
                                        <Typography align="right" style={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '11px' }}>Select A Member</Typography>
                                        <FormControl style={{ paddingLeft: '11px' }}>
                                            <Select
                                                value={this.state.addUser}
                                                onChange={this.handleAddUserSelect}
                                                autoWidth={true}
                                                style={{ width: '134px' }}
                                            //inputProps={{ style: { minHeight: '25px' } }}
                                            >
                                                {this.props.members.map((member, i) => <MenuItem style={{ minHeight: '25px' }} key={i} value={member.firstName + " " + member.lastName}>{member.firstName + " " + member.lastName}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/*Button to add selected member to selected group*/}
                                    <Grid item xs={12} style={{ textAlign: 'right' }}>
                                        <Button onClick={this.handleAddUser} variant="contained" color="primary" style={{ margin: '5px' }}>
                                            Add
                    </Button>
                                    </Grid>

                                </Grid>
                            </Card>
                        </Grid>

                        {/*Add A Group*/}
                        <Grid item xs={12} style={{}}>
                            <Card style={{}}>

                                {/*Add A Group Card*/}
                                <Grid container item xs={12}>

                                    {/*Add A Group Title*/}
                                    <Grid item xs={12} style={{ marginBottom: '8px' }}>
                                        <Typography align="center" style={{ fontWeight: 'bold', padding: '5px', fontSize: '16px' }}>Add A Group</Typography>
                                    </Grid>

                                    {/*Enter in a new group name*/}
                                    <Grid item xs={12}>
                                        <Typography align="left" style={{ fontWeight: 'bold', textAlign: 'left', paddingLeft: '15px' }}>Group Name</Typography>
                                        <TextField
                                            autoFocus
                                            margin="normal"
                                            id="firstName"
                                            type="name"
                                            value={this.state.addGroup}
                                            onChange={this.handleAddNewGroupChange}
                                            fullWidth
                                            style={{ paddingLeft: '15px', width: '303px', marginTop: '0px', marginBottom: '1px' }}
                                        />
                                    </Grid>

                                    {/*Button to add a new group*/}
                                    <Grid item xs={12} style={{ textAlign: 'right' }}>
                                        <Button onClick={this.addAGroup} variant="contained" color="primary" style={{ margin: '5px' }}>
                                            Add
                      </Button>
                                    </Grid>

                                </Grid>
                            </Card>
                        </Grid>

                    </Grid>

                    {/*Remove Group and Remove User Buttons*/}
                    <Grid justify="flex-start" container item xs={5} style={{ justifyContent: 'left' /*, paddingLeft: '57px', paddingTop: '5px'*/ }}>
                        <Button onClick={this.handleShowRemoveGroupConfirm} variant="contained" color="primary" style={{ padding: '6px', margin: '5px', marginLeft: '28px' }}>
                            Remove Group
            </Button>
                        <Button onClick={this.handleRemoveUserFromGroup} variant="contained" color="primary" style={{ padding: '6px', margin: '5px' }}>
                            Remove User
            </Button>
                    </Grid>

                    {this.state.showError &&
                        <Grid justify="flex-start" container item xs={7} style={{ /*justifyContent: 'left', paddingLeft: '57px', paddingTop: '5px'*/ }}>
                            <p style={{ color: '#ff0000', fontSize: '12px', paddingTop: '10px', margin: '0px', textAlign: 'center' }}>
                                Please select the group to be removed.
              </p>
                        </Grid>
                    }

                    {this.state.showRemoveGroupConfirm &&
                        <Grid justify="flex-start" container item xs={7} style={{ /*justifyContent: 'left', paddingLeft: '57px', paddingTop: '5px'*/ }}>
                            <p style={{ color: '#ff0000', fontSize: '12px', paddingTop: '10px', margin: '0px', textAlign: 'center' }}>Remove <b>{this.state.selectedGroupName}</b> group?</p>
                            <Button onClick={this.handleRemoveGroupConfirm} variant="contained" style={{ padding: '6px', margin: '5px', color: 'white', backgroundColor: 'green' }}>YES</Button>
                            <Button onClick={this.closeRemoveGroupConfirm} variant="contained" color="secondary" style={{ padding: '6px', margin: '5px' }}>NO</Button>
                        </Grid>
                    }

                </Grid>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        members: state.members,
        profile: state.profile,
        currentUser: state.currentUser,
        memberIdMap: state.memberIdMap,
        memberNameMap: state.memberNameMap,
    };
}

export default connect(mapStateToProps, null)(ManageGroup);


// WEBPACK FOOTER //
// ./src/components/ManageGroup.js